export default "__VITE_ASSET__Dlxch2jd__"